export default __webpack_public_path__ + "c689ba89bd24f0f81cad75a2ab75193f.svg";